/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@/client";
import type { GetGetPrintPriceListQueryResponse, GetGetPrintPriceListPathParams, GetGetPrintPriceListQueryParams } from "../../models/GetGetPrintPriceList";
import type { RequestConfig, ResponseErrorConfig } from "@/client";

function getGetGetPrintPriceListUrl({ debtorCode }: { debtorCode: GetGetPrintPriceListPathParams["debtorCode"] }) {
  const res = { method: 'GET', url: `/api/v1/debtors/${debtorCode}/print-price-list` as const }  
  return res
}

/**
 * {@link /api/v1/debtors/:debtorCode/print-price-list}
 */
export async function getGetPrintPriceList({ debtorCode, params }: { debtorCode: GetGetPrintPriceListPathParams["debtorCode"]; params: GetGetPrintPriceListQueryParams }, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<GetGetPrintPriceListQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getGetGetPrintPriceListUrl({ debtorCode }).url.toString(), params, ... requestConfig })  
  return res.data
}